import { useSiteData } from "@/context/SiteDataContext";
import { waLink } from "@/lib/api";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const WhatsAppFloat = () => {
  const { settings } = useSiteData();
  return (
    <a
      href={waLink(settings.whatsapp, "Hi Ocean Wings Travel, I'm planning an Andaman trip. Please share details.")}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-floating-button"
      className={`fixed hidden lg:grid bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-emerald-500 text-white place-items-center shadow-xl shadow-emerald-900/30 hover:scale-110 hover:bg-emerald-600 transition-[transform,background-color] duration-300`}
    >
      <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-30" />
      <WhatsAppIcon className="h-7 w-7 relative" />
    </a>
  );
};
